import { apiClient } from '@/lib/api/apiClient';

export interface UploadResponse {
  url: string;
}

const UPLOAD_ENDPOINT = '/api/admin/upload';

export const uploadService = {
  /**
   * Upload an image for sections
   */
  async uploadSectionImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`${UPLOAD_ENDPOINT}/section-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data.url;
  },

  /**
   * Upload an image for categories
   */
  async uploadCategoryImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`${UPLOAD_ENDPOINT}/category-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data.url;
  },

  /**
   * Upload an image for questions
   */
  async uploadQuestionImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`${UPLOAD_ENDPOINT}/question-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data.url;
  },

  /**
   * Upload a general image
   */
  async uploadImage(file: File, folder: string = 'general'): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(`${UPLOAD_ENDPOINT}/image?folder=${folder}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data.data.url;
  },

  /**
   * Delete an uploaded image
   */
  async deleteImage(url: string): Promise<void> {
    await apiClient.delete(`${UPLOAD_ENDPOINT}/image?url=${encodeURIComponent(url)}`);
  },

  /**
   * Validate file before upload
   */
  validateFile(file: File, maxSizeMB: number = 5): { valid: boolean; error?: string } {
    const maxSize = maxSizeMB * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

    if (file.size > maxSize) {
      return { valid: false, error: `حجم الملف يجب أن يكون أقل من ${maxSizeMB} ميجابايت` };
    }

    if (!allowedTypes.includes(file.type)) {
      return { valid: false, error: 'نوع الملف غير مدعوم. الأنواع المدعومة: JPG, PNG, GIF, WebP' };
    }

    return { valid: true };
  },
};
